/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountActiveTicketListResponse } from '../models/AccountActiveTicketListResponse';
import type { AccountCartLifetimeResponse } from '../models/AccountCartLifetimeResponse';
import type { ApiResponse } from '../models/ApiResponse';
import type { CustomerAccountSettingResponse } from '../models/CustomerAccountSettingResponse';
import type { CustomerListResponse } from '../models/CustomerListResponse';
import type { EmailExistsResponse } from '../models/EmailExistsResponse';
import type { UpdateCustomerAccountSettingCommand } from '../models/UpdateCustomerAccountSettingCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EshopCustomerAccountService {
    /**
     * Get card application.
     * @returns CustomerListResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerGetAccountRelatedCustomers({
        adultOnly,
    }: {
        adultOnly?: boolean,
    }): CancelablePromise<CustomerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/eshop/customer-accounts-related-customers',
            query: {
                'adultOnly': adultOnly,
            },
            errors: {
                401: `User wasn't authenticated.`,
                403: `User didn't have permissions to perform this action.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Update account setting.
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     * @returns CustomerAccountSettingResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerUpdateSettings({
        mapPhoneAuthToken,
        requestBody,
    }: {
        mapPhoneAuthToken?: any,
        /**
         * UpdateCustomerAccountSettingCommand
         */
        requestBody?: UpdateCustomerAccountSettingCommand,
    }): CancelablePromise<CustomerAccountSettingResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/eshop/customer-accounts/settings',
            headers: {
                'map-phone-auth-token': mapPhoneAuthToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Get active tickets from registered or assigned customers for account.
     * @returns AccountActiveTicketListResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerGetAccountActiveTickets(): CancelablePromise<AccountActiveTicketListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/eshop/customer-accounts-active-tickets',
            errors: {
                401: `User wasn't authenticated.`,
                403: `User didn't have permissions to perform this action.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Remove customer eshop account.
     * @returns ApiResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerRemoveCustomerAccount(): CancelablePromise<ApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/eshop/customer-accounts',
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                404: `Resource wasn't found.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Get customer cart lifetime.
     * @returns AccountCartLifetimeResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerGetCustomerCartLifeTime(): CancelablePromise<AccountCartLifetimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/eshop/customer-accounts/cart-lifetime',
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                404: `Resource wasn't found.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Null customer cart lifetime.
     * @returns any Successful response
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerNullCustomerCartLifetime(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/eshop/customer-accounts/cart-lifetime-nullify',
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                404: `Resource wasn't found.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Change child account to regular account.
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CANNOT_CHANGE_CHILD_ACCOUNT_TO_REGULAR_ACCOUNT** - Only a child account, for which a legal representative is no longer required based on the date of birth, can be converted to a regular account.
     * @returns ApiResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerChangeChildAccountToRegularAccount(): CancelablePromise<ApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/eshop/customer-accounts/child-to-regular-account',
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                404: `Resource wasn't found.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Verify if email exists in the database.
     * @returns EmailExistsResponse
     * @throws ApiError
     */
    public static eshopCustomerAccountControllerVerifyEmailExists({
        email,
    }: {
        email: string,
    }): CancelablePromise<EmailExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/eshop/customer-accounts/email/{email}/exists',
            path: {
                'email': email,
            },
            errors: {
                400: `Validation failed.`,
                401: `User wasn't authenticated.`,
                500: `Something went wrong.`,
            },
        });
    }
}
